import { ref, computed, onUnmounted } from "vue";

export function usePolling(fetchFn, { interval = 60000 } = {}) {
  const lastRefreshed = ref(null);
  let pollTimer = null;
  let tickTimer = null;
  // Reactive tick counter to force lastRefreshedText recomputation
  const tick = ref(0);

  const lastRefreshedText = computed(() => {
    // Access tick so Vue tracks it as a dependency
    void tick.value;
    if (!lastRefreshed.value) return "";
    const diff = Math.floor((Date.now() - lastRefreshed.value.getTime()) / 60000);
    if (diff < 1) return "just now";
    if (diff === 1) return "1 min ago";
    return `${diff} min ago`;
  });

  function startPollTimer() {
    stopPollTimer();
    pollTimer = setInterval(() => poll(), interval);
  }

  function stopPollTimer() {
    if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  async function poll() {
    await fetchFn();
    lastRefreshed.value = new Date();
  }

  function refresh() {
    lastRefreshed.value = new Date();
    startPollTimer();
    fetchFn();
  }

  function onVisibilityChange() {
    if (document.hidden) {
      stopPollTimer();
    } else {
      poll();
      startPollTimer();
    }
  }

  // Start the label ticker (updates "X min ago" every 30s)
  tickTimer = setInterval(() => {
    tick.value++;
  }, 30000);

  // Start polling + visibility listener
  startPollTimer();
  document.addEventListener("visibilitychange", onVisibilityChange);

  onUnmounted(() => {
    stopPollTimer();
    if (tickTimer) {
      clearInterval(tickTimer);
      tickTimer = null;
    }
    document.removeEventListener("visibilitychange", onVisibilityChange);
  });

  return { lastRefreshedText, lastRefreshed, refresh };
}
